import { Component, Input } from '@angular/core';
import { convertNumberToAcronyms } from 'src/app/common/numberUtils';
import { AggregationDict } from 'src/app/models/api/aggregations.model';
import { AggregationCategorySumDetails } from 'src/app/models/api/dashboards.model';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';

@Component({
  selector: 'app-base-top-data-chart',
  templateUrl: './base-top-data-chart.component.html',
  styleUrls: ['./base-top-data-chart.component.scss'],
})
export class BaseTopDataChartComponent {
  @Input() public title: string;
  @Input() public tooltip: string;
  @Input() public seriesData: AggregationCategorySumDetails[];
  @Input() public filterOptions: ISelectedFilters;

  public getSubCategoryAmount(amountPerSubCategory: AggregationDict, subCategory: string): string {
    return convertNumberToAcronyms(amountPerSubCategory[subCategory] ?? 0);
  }
}
